/* eslint-disable no-underscore-dangle */
import {
  LIBRARY_REMOTE_ENTRY_END_POINT,
  LIBRARY_SCOPE,
  LIBRARY_MODULE_NAME_PATH_PREFIX,
} from 'constants'
import { loadRemoteMFModule, loadScript } from 'utils/common'

const bootstrap = () => {
  // eslint-disable-next-line no-underscore-dangle
  if (!window.__affiliates_libarary_promise) {
    // eslint-disable-next-line no-underscore-dangle
    window.__affiliates_libarary_promise = loadScript(
      LIBRARY_REMOTE_ENTRY_END_POINT
    )
  }
  return window.__affiliates_libarary_promise
}

const loadComponent = (componentName) =>
  loadRemoteMFModule(
    LIBRARY_SCOPE,
    `${LIBRARY_MODULE_NAME_PATH_PREFIX}${componentName}`
  )

export default {
  bootstrap,
  loadComponent,
}
